module.exports = __webpack_public_path__ + "img/fig9.10.978b597c.png";